import { useSelector } from 'react-redux';
import { getPersonalGroupId, getRights, getUsersSourceSetModel } from './index';

export const usePersonalGroupId = () => useSelector(getPersonalGroupId);
export const useRights = () => useSelector(getRights);
export const useUsersSourceSetModel = () => useSelector(getUsersSourceSetModel);
